/**
 * @fileoverview FileThumbnails Component - File Navigation with Thumbnails
 *
 * A reusable component for displaying uploaded file thumbnails with folder icon.
 * Used in ConfigureStep and PreviewStep for file navigation.
 *
 * @requires React
 */
import React from 'react';

/**
 * FileThumbnails Component
 *
 * @param {Object} props
 * @param {Array} props.files - Array of file objects with preview property
 * @param {number} props.currentIndex - Index of the currently selected file
 * @param {Function} props.onIndexChange - Callback when a thumbnail is clicked
 * @returns {JSX.Element|null}
 */
function FileThumbnails({ files, currentIndex, onIndexChange }) {
  if (!files || files.length === 0) return null;

  return (
    <div className="flex justify-center mb-4">
      <div className="inline-flex items-center gap-3 bg-white/5 backdrop-blur border border-white/10 rounded-xl px-3 py-2">
        {/* Folder icon with count badge */}
        <div className="flex flex-col items-center gap-0.5">
          <span className="text-lg">📁</span>
          <span className="bg-emerald-500/30 text-emerald-300 text-[10px] font-bold px-1.5 py-0.5 rounded-full border border-emerald-500/50">
            {files.length}
          </span>
        </div>
        {/* Separator */}
        <div className="h-8 w-px bg-white/20"></div>
        {/* Thumbnails */}
        <div className="flex items-center gap-2">
          {files.map((f, i) => (
            <button
              key={i}
              onClick={() => onIndexChange(i)}
              className={`relative p-0.5 rounded-lg transition-all ${
                currentIndex === i
                  ? 'ring-2 ring-emerald-500 bg-emerald-500/20'
                  : 'hover:bg-white/10 opacity-60 hover:opacity-100'
              }`}
            >
              <img src={f.preview} alt="" className="w-10 h-10 rounded-md object-cover" />
              {currentIndex === i && (
                <div className="absolute -bottom-1 left-1/2 -translate-x-1/2 w-1.5 h-1.5 bg-emerald-500 rounded-full"></div>
              )}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}

export default FileThumbnails;
